import { RouteRecordRaw } from 'vue-router'

const projectRoutes: Array<RouteRecordRaw> = [
  {
    path: '/projects/:id',
    name: 'project',
    component: () => import('@/views/project/ProjectView.vue')
  },
  {
    path: '/player/:media',
    name: 'project-player',
    component: () => import('@/components/Players/MainPlayer/MainPlayer.vue'),
    meta: {
      layout: 'Player'
    }
  }
]

export default projectRoutes
